/**
 * Класс отвечает за хранение событий, подписку на события и уведомления о срабатывани события
 * {@link #store} объект-хранилище событий и коллбек функций для события:
 * - свойство объекта является типом события;
 * - значением свойства является массив коллбек функций для события;
 */
export default class EventEmitter {
   #store = {}

   constructor() {
   }

   /**
    * Метод подписки на событие
    * @param eventType     - строка с названием события
    * @param newCallback   - коллбек функция которую необходимо вызвать при срабатывании события
    */
   onSubscribe = (eventType, newCallback) => {
      if (this.#store.hasOwnProperty(eventType)) {
         this.#store[eventType].push(newCallback)
      } else {
         this.#store = {
            ...this.#store,
            [eventType]: [newCallback],
         }
      }
      // console.log("onSubscribe after add:", this.#store)
      return this.#store[eventType].filter(callback => callback !== newCallback)
   }

   /**
    * Метод вещания события
    * @param eventType - строка с типом события для вещания
    */
   onEmit = (eventType) => {
      // console.log("onEmit eventType:", eventType)
      this.#store[eventType]?.forEach(callback => callback())
   }
}